import { Theme } from '@mui/material';

export const FONT_SIZE = '0.875rem';

export interface FieldStyleConfig {
  hasValue: boolean;
  hasError?: boolean;
}

export const createFieldStyles = (
  theme: Theme,
  { hasValue, hasError = false }: FieldStyleConfig
) => {
  let borderColor;
  if (hasError) {
    borderColor = theme.palette.error.main;
  } else if (hasValue) {
    borderColor = theme.palette.primary.main;
  } else {
    borderColor = undefined;
  }

  const borderWidth = hasError || hasValue ? '2px' : '1px';

  return {
    '& .MuiOutlinedInput-root': {
      backgroundColor: hasValue ? `${theme.palette.primary.light}20` : 'transparent',
      '& fieldset': {
        borderColor,
        borderWidth,
      },
      '&:hover fieldset': {
        borderColor,
      },
      '&.Mui-focused fieldset': {
        borderColor,
      },
    },
  };
};

export const createLabelProps = (
  theme: Theme,
  { hasValue, hasError = false }: FieldStyleConfig
) => {
  let color;
  if (hasError) {
    color = theme.palette.error.main;
  } else if (hasValue) {
    color = theme.palette.primary.main;
  } else {
    color = undefined;
  }

  const fontWeight = hasError || hasValue ? 600 : 400;

  return {
    shrink: true,
    sx: {
      fontSize: FONT_SIZE,
      color,
      fontWeight,
    },
  };
};
